import React from 'react';
import { Link } from 'react-router-dom';
import {
  FiFileText, FiCreditCard, FiRepeat, FiUsers, FiUser, FiDollarSign,
  FiClock, FiMonitor, FiTool, FiTruck, FiBox, FiList, FiTrendingUp,
  FiBookOpen, FiBarChart2, FiPieChart, FiActivity,
} from 'react-icons/fi';
import { REPORT_DEFS } from '../../config/reports';
import PageHeader from '../../components/common/PageHeader';

const ICONS = {
  invoices: <FiFileText />,
  payments: <FiCreditCard />,
  vouchers: <FiRepeat />,
  parties: <FiUsers />,
  'party-statement': <FiActivity />,
  employees: <FiUser />,
  payroll: <FiDollarSign />,
  attendance: <FiClock />,
  machines: <FiMonitor />,
  stitches: <FiTool />,
  gatepasses: <FiTruck />,
  inventory: <FiBox />,
  'activity-logs': <FiList />,
  'sales-summary': <FiTrendingUp />,
  'invoice-summary-details': <FiFileText />,
  'invoice-summary': <FiFileText />,
};

const FINANCIAL = [
  { key: 'ledger', label: 'Ledger', icon: <FiBookOpen />, to: '/reports/ledger', desc: 'Account-wise ledger with running balance' },
  { key: 'accounts-balances', label: 'Accounts Balances', icon: <FiBarChart2 />, to: '/reports/accounts-balances', desc: 'All account opening balances with ledger' },
  { key: 'trial-balance', label: 'Trial Balance', icon: <FiBarChart2 />, to: '/reports/trial-balance', desc: 'Debit and credit totals per account' },
  { key: 'income-statement', label: 'Income Statement', icon: <FiPieChart />, to: '/reports/income-statement', desc: 'Income, expenses and net profit' },
  { key: 'balance-sheet', label: 'Balance Sheet', icon: <FiActivity />, to: '/reports/balance-sheet', desc: 'Assets, liabilities and equity' },
];

export default function Reports() {
  return (
    <div className="page">
      <PageHeader
        title="Reports"
        subtitle="Financial, operational and management reports."
        crumbs={[{ label: 'Reports' }]}
      />

      <div className="section-title">Financial Reports</div>
      <div className="stats-grid">
        {FINANCIAL.map((r) => (
          <Link key={r.key} to={r.to} className="stat-card">
            <div className="stat-icon indigo">{r.icon}</div>
            <div>
              <div className="stat-value" style={{ fontSize: 16 }}>{r.label}</div>
              <div className="stat-label">{r.desc}</div>
            </div>
          </Link>
        ))}
      </div>

      <div className="section-title">Operational Reports</div>
      <div className="stats-grid">
        {REPORT_DEFS.map((r) => (
          <Link key={r.key} to={`/reports/${r.key}`} className="stat-card">
            <div className="stat-icon blue">{ICONS[r.key] || <FiFileText />}</div>
            <div>
              <div className="stat-value" style={{ fontSize: 16 }}>{r.label}</div>
              <div className="stat-label">View & export report</div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}